/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { SourceIntegration } from '../model';
// @ts-ignore
import type { SourceIntegrationBulkUpdate } from '../model';
// @ts-ignore
import type { SourceIntegrationUpdate } from '../model';
/**
 * SourcesApi - axios parameter creator
 */
export const SourcesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update multiple organization source integrations\' enabled status.
         * @summary Bulk update supported source types
         * @param {SourceIntegrationBulkUpdate} sourceIntegrationBulkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateSupportedSourceTypes: async (sourceIntegrationBulkUpdate: SourceIntegrationBulkUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceIntegrationBulkUpdate' is not null or undefined
            assertParamExists('bulkUpdateSupportedSourceTypes', 'sourceIntegrationBulkUpdate', sourceIntegrationBulkUpdate)
            const localVarPath = `/sources/supported-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sourceIntegrationBulkUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of supported source types
         * @summary Get Supported Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedSourceTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sources/supported-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an organization integration\'s enabled status.
         * @summary Update Supported Source Types
         * @param {SourceIntegrationUpdate} sourceIntegrationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportedSourceTypes: async (sourceIntegrationUpdate: SourceIntegrationUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceIntegrationUpdate' is not null or undefined
            assertParamExists('updateSupportedSourceTypes', 'sourceIntegrationUpdate', sourceIntegrationUpdate)
            const localVarPath = `/sources/supported-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sourceIntegrationUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SourcesApi - functional programming interface
 */
export const SourcesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SourcesApiAxiosParamCreator(configuration)
    return {
        /**
         * Update multiple organization source integrations\' enabled status.
         * @summary Bulk update supported source types
         * @param {SourceIntegrationBulkUpdate} sourceIntegrationBulkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateSupportedSourceTypes(sourceIntegrationBulkUpdate: SourceIntegrationBulkUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceIntegration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateSupportedSourceTypes(sourceIntegrationBulkUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.bulkUpdateSupportedSourceTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of supported source types
         * @summary Get Supported Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedSourceTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SourceIntegration>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedSourceTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.getSupportedSourceTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an organization integration\'s enabled status.
         * @summary Update Supported Source Types
         * @param {SourceIntegrationUpdate} sourceIntegrationUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSupportedSourceTypes(sourceIntegrationUpdate: SourceIntegrationUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceIntegration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSupportedSourceTypes(sourceIntegrationUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourcesApi.updateSupportedSourceTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SourcesApi - factory interface
 */
export const SourcesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SourcesApiFp(configuration)
    return {
        /**
         * Update multiple organization source integrations\' enabled status.
         * @summary Bulk update supported source types
         * @param {SourcesApiBulkUpdateSupportedSourceTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateSupportedSourceTypes(requestParameters: SourcesApiBulkUpdateSupportedSourceTypesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceIntegration>> {
            return localVarFp.bulkUpdateSupportedSourceTypes(requestParameters.sourceIntegrationBulkUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of supported source types
         * @summary Get Supported Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedSourceTypes(options?: RawAxiosRequestConfig): AxiosPromise<Array<SourceIntegration>> {
            return localVarFp.getSupportedSourceTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * Update an organization integration\'s enabled status.
         * @summary Update Supported Source Types
         * @param {SourcesApiUpdateSupportedSourceTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupportedSourceTypes(requestParameters: SourcesApiUpdateSupportedSourceTypesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SourceIntegration> {
            return localVarFp.updateSupportedSourceTypes(requestParameters.sourceIntegrationUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkUpdateSupportedSourceTypes operation in SourcesApi.
 */
export interface SourcesApiBulkUpdateSupportedSourceTypesRequest {
    readonly sourceIntegrationBulkUpdate: SourceIntegrationBulkUpdate
}

/**
 * Request parameters for updateSupportedSourceTypes operation in SourcesApi.
 */
export interface SourcesApiUpdateSupportedSourceTypesRequest {
    readonly sourceIntegrationUpdate: SourceIntegrationUpdate
}

/**
 * SourcesApi - object-oriented interface
 */
export class SourcesApi extends BaseAPI {
    /**
     * Update multiple organization source integrations\' enabled status.
     * @summary Bulk update supported source types
     * @param {SourcesApiBulkUpdateSupportedSourceTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkUpdateSupportedSourceTypes(requestParameters: SourcesApiBulkUpdateSupportedSourceTypesRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).bulkUpdateSupportedSourceTypes(requestParameters.sourceIntegrationBulkUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of supported source types
     * @summary Get Supported Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSupportedSourceTypes(options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).getSupportedSourceTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an organization integration\'s enabled status.
     * @summary Update Supported Source Types
     * @param {SourcesApiUpdateSupportedSourceTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSupportedSourceTypes(requestParameters: SourcesApiUpdateSupportedSourceTypesRequest, options?: RawAxiosRequestConfig) {
        return SourcesApiFp(this.configuration).updateSupportedSourceTypes(requestParameters.sourceIntegrationUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

